import { render, staticRenderFns } from "./ReviewsSection.vue?vue&type=template&id=d80f7596&scoped=true"
import script from "./ReviewsSection.vue?vue&type=script&lang=js"
export * from "./ReviewsSection.vue?vue&type=script&lang=js"
import style0 from "./ReviewsSection.vue?vue&type=style&index=0&id=d80f7596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80f7596",
  null
  
)

export default component.exports